module.exports = __webpack_public_path__ + "static/media/google-play-badge.ed4d7915.svg";